import axios from "axios";

const api = axios.create({
  baseURL: "https://alexander-example-aye-papers.trycloudflare.com" ,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;